<template lang="">
  <div class="d-flex">
    <form @submit.prevent="submit" class="d-flex flex-column flex-grow-1">
      <v-container>

      <!-------------------------------- Bloc nouveau projet -------------------------------->
      <v-col cols="12" sm="10" class="pb-0  mt-10">
        <div class="text-left">NOM PROJET (mois-année application produit1..produit2...etc)*</div>
        <v-text-field label="mois-année application produit1..produit2...etc" single-line outlined v-model="projet.nom_projet" hide-details dense></v-text-field>
            <!-- message d'erreur -->
          <div class="errorMsg" v-if="$v.projet.nom_projet.$error && $v.projet.nom_projet.required == false">
            Renseignez le nom du projet.
          </div>

          <div class="errorMsg" v-if="$v.projet.nom_projet.$error && ($v.projet.nom_projet.required == true && $v.projet.nom_projet.minLength == false) ">
            4 caractères au minimum.
          </div>

          <div class="errorMsg" v-if="$v.projet.nom_projet.$error && ($v.projet.nom_projet.required == true && $v.projet.nom_projet.maxLength == false) ">
            100 caractères au maximum.
          </div>
          <!-- message d'erreur -->
        </v-col>

    <v-row class="mt-2" align-self="end" align="center" no-gutters>
      <v-col cols="4" sm="3" class=" pl-3 mt-1">
        <div class="text-left">
        DATE DU PROJET*
        </div>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          light
        >
          <template v-slot:activator="{ on, attrs }">
            <span class="calendar-field">
              <v-text-field
                :value="formatDate"
                dense
                readonly
                v-bind="attrs"
                v-on="on"
                single-line
                light
                outlined
                hide-details
              >
                <template slot="append-outer">
                  <img class="ml-2" src="@/assets/calendar.png" alt="Calendrier" />
                </template>
              </v-text-field>
            </span>
          </template>                                <!-- message d'erreur -->

          <v-date-picker
            v-model="projet.date_projet"
            no-title
            locale="fr-fr"
            @input="menu = false"
          ></v-date-picker>

        </v-menu>
                                  <div class="errorMsg" v-if="$v.projet.date_projet.$error">
            Renseignez la date du projet
          </div>
      </v-col>


      <v-col cols="4" sm="4" class="pl-10 mt-1">
          <div class="text-left">CREATEUR</div>

        <v-select
          :items="utilisateurs"
          item-value="id_utilisateur"
          item-text="nom"
          v-model="projet.id_utilisateur"
          item-color='primary'
          class="text-color"
          hide-details
          solo
        ></v-select>

      </v-col>
    </v-row>
      <v-row class="mt-4" align-self="end" align="center"  no-gutters>
        <v-col cols="4" class="pl-3" align="left">
          <label>PROJET BLOC FORE
            <input type="checkbox" v-model="projet.bloc_fore" style="width: 30px; height:20px;" />
          </label>
        </v-col>
      </v-row>

      <v-row v-if="projet.bloc_fore">
        <v-col cols="12" class="pl-3 pb-0">
          <v-tabs v-model="activeTab" background-color="#0B87BA" dark>
            <v-tab>
              Projet
              <v-icon v-if="tabErrors[0]" small color="#ff5252" class="ml-1">mdi-alert-circle</v-icon>
            </v-tab>
            <v-tab>
              Cahier des charges
              <v-icon v-if="tabErrors[1]" small color="#ff5252" class="ml-1">mdi-alert-circle</v-icon>
            </v-tab>
            <v-tab>Calcul du coût</v-tab>
            <v-tab>Calcul prix de vente</v-tab>
            <v-tab>Offre commerciale</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

            <!-- Tab content -->
      <div v-show="!projet.bloc_fore || activeTab === 0">

    <!-------------------------------- Bloc Personnes rencontrées -------------------------------->
 <AddContacts :personnes="projet.personnes" @emitPersonnes="projet.personnes = $event" ref="AddContacts" />

  <div class="text-left pl-4 errorMsg" v-if="checkIfPersonne && projet.personnes.length === 0">
    Au moins une personne doit être rajoutée*
  </div>


      <!-------------------------------- BLOC PERSONNES RENCONTREES -------------------------------->
      <!-------------------------------- BLOC DESCRIPTION -------------------------------->
 <ProjetBlocDescription :projet="projet" tab="Projet" ref="ProjetBlocDescription" />

      <!-------------------------------- BLOC DESCRIPTION -------------------------------->

      <!-------------------------------- BLOC CHRONOLOGIE DES ETAPES -------------------------------->
        <ProjetEtapes v-if="projet.bloc_fore" :projet="projet" ref="ProjetEtapes" />

      <!-------------------------------- BLOC DESCRIPTION -------------------------------->

      <!-------------------------------- BLOC COMMENTAIRE-------------------------------->
      <v-col cols="12" sm="10" class="pb-0 mt-10">
        <v-toolbar color="#0B87BA" flat dense>
          <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
            COMMENTAIRE
          </v-col>
        </v-toolbar>
      </v-col>

      <v-col cols="12" sm="10" class="alignement_input">
        <v-textarea outlined auto-grow rows="1" v-model="projet.commentaire_"></v-textarea>
      </v-col>

      <!-------------------------------- BLOC COMMENTAIRE-------------------------------->
      <!-------------------------------- BLOC HISTORIQUE DES COMMENTAIRES-------------------------------->
    <div v-if="projet.id_projet && projet.commentaires.length > 0">
      <v-col  cols="12" sm="10" class="pb-0  mt-10">
        <v-toolbar color="#0B87BA" flat dense>
          <v-col
            cols="6"
            lg="6"
            xl="2"
            class="pa-0 font_color text-left"
          >
            HISTORIQUE DES COMMENTAIRES
          </v-col>
        </v-toolbar>
      </v-col>

      <v-col cols="12" sm="10"  class="text-left ">
        <div v-for="commentaire in projet.commentaires.slice().reverse()" :key="commentaire.createdAt">
          <div class="date-letter text-uppercase ">{{commentaire.User.nom}} - {{ commentaire.createdAt ? $moment(commentaire.createdAt).format("LL") : "" }}</div>
          <div class="font-italic text-h6 " style="overflow-wrap: break-word;">"{{ commentaire.commentaire }}"</div>
        </div>
      </v-col>
    </div>
      <!-------------------------------- BLOC HISTORIQUE DES COMMENTAIRES-------------------------------->
      <AddRappels :rappels="projet.rappels" ref="AddRappels" @closeRappel="closeRappel" />
      <div class="text-left pl-3" v-if="projet.rappels.length == 0">
        Aucun rappel n'a été ajouté
      </div>
      <!-------------------------------- BLOC PIECES JOINTES-------------------------------->
      <AddDocuments
        :project="projet"
        :filesToAdd="filesToAdd"
        ref="AddDocuments"
      />

      <!-------------------------------- BLOC PIECES JOINTES-------------------------------->
      <!-------------------------------- BLOC ETAT DU PROJET-------------------------------->
      <div  >
      <v-col cols="12" sm="10" class="pb-0  mt-10">
        <v-toolbar color="#0B87BA" flat dense>
          <v-col
            cols="6"
            lg="6"
            xl="2"
            class="pa-0 font_color text-left"
          >
            ETAT DU PROJET
          </v-col>
        </v-toolbar>
      </v-col>
      <v-col cols="12" sm="10" class="pb-0">
        <div class="d-flex">
          <div class="text-left mt-5">PROJET OBTENU</div>
          <v-radio-group class="ml-10" row v-model="projet.projet_obtenu">
            <v-radio label="OUI" v-bind:value="true"></v-radio>
            <v-radio label="NON" v-bind:value="false"></v-radio>
          </v-radio-group>
        </div>
      </v-col>

      <v-col cols="12" sm="10"  class="alignement_input ">
        <div v-if="projet.projet_obtenu !== null" class="text-left">COMMENTAIRE*</div>
        <v-textarea v-if="projet.projet_obtenu !== null" outlined auto-grow rows="1" v-model="projet.commentaire_projet_obtenu"></v-textarea>

      </v-col>
      </div>
      <!-------------------------------- BLOC ETAT DU PROJET-------------------------------->
      </div>

      <div v-show="projet.bloc_fore && activeTab === 1">
        <ProjetBlocDescription :projet="projet" tab="Cahier_des_charges" ref="ProjetBlocDescriptionCahier" />
        <AddArticles :retour_a_articles="projet.projet_a_articles" :blocFore="true" />


        <div class="mt-3">
          <BlocPlan :src="blocSrc" :isPdf="blocIsPdf" :zoomLevel="zoomLevel" />
          <div class="mt-3 mb-3">
            <v-btn class="btnBold ml-16" color="#FF9900" dark rounded @click="onButtonClick">
              <v-icon left>fa fa-plus</v-icon>
              Ajouter une image ou un PDF
            </v-btn>
            <input ref="uploader" class="d-none" type="file" accept="image/*,application/pdf" @change="onFileChanged" />
            <v-btn v-if="!blocIsPdf" @click="zoomOut">Zoom -</v-btn>
            <v-btn v-if="!blocIsPdf" @click="zoomIn">Zoom +</v-btn>
          </div>
        </div>

  <v-toolbar color="#0B87BA" flat dense>
          <v-col
            cols="12"
            lg="12"
            xl="12"
            class="pa-0 font_color text-left"
          >
            IMPLANTATIONS ET DIMENSIONS - indiquez les dimensions hors-tout (cartouches inclues)
          </v-col>

    <v-col cols="6" lg="6" xl="4" offset-xl="2"  class="pa-0 text-right">
     </v-col>
        </v-toolbar>
        <v-row>
            <v-col cols="8" sm="8"  class=" mt-5 text-left">
              <img  src="@/assets/dimensions.png" style="width:70%; height:70%" alt=""/>
            </v-col>
              <v-col cols="4" sm="4"  class=" mt-5 text-left">
                <div class="text-left">Longueur</div>
                <v-text-field single-line outlined v-model="projet.longueur" hide-details dense></v-text-field>
                <div class="mt-3 text-left">Largeur</div>
                <v-text-field single-line outlined v-model="projet.largeur" hide-details dense></v-text-field>
                <div class="mt-3 text-left">Hauteur</div>
                <v-text-field single-line outlined v-model="projet.hauteur" hide-details dense></v-text-field>
            </v-col>

        </v-row>



<v-container>
        <v-row class="table-fields">
          <v-col cols="12" sm="12" class="pb-0">
  <div class="text-left"><b>FACE 6 (Face de fixation du bloc) : Indiquez si trous débouchants sur face 3 ou trous taraudes:</b></div>
  <v-text-field single-line outlined v-model="projet.face_6" hide-details dense></v-text-field>

  </v-col>

       <v-col cols="12" sm="12" class="pb-0 ">
            <p class="text-left "><b> Indiquez sur les faces l'implantation des cartouches et des ports(nom et taille). Indiquez les éventuels réglages. <br>
    Si le bloc est à flasquer sur un distributeur, merci d'indiquer le modèle et la face d'attachement.</b></p>
      </v-col>
  </v-row>

  <v-row class="table-header">
    <v-col v-for="(column, index) in columns" :key="index" cols="2">
      <h2>{{ column }}</h2>
    </v-col>
  </v-row>
  <div v-if="projet.rows && projet.rows.length > 0">
    <v-row v-for="(row, rowIndex) in projet.rows" :key="rowIndex" class="table-row">
      <v-col v-for="(column, index) in columns" :key="index" cols="2" class="table-cell" style="height: auto;">
        <v-text-field v-model="row['face' + (index + 1)]" :label="'Face ' + (index + 1)" single-line outlined hide-details dense></v-text-field>
      </v-col>
    </v-row>
  </div>
  <v-row>
    <v-col>
      <v-btn @click="removeRow()">Supprimer la dernière ligne</v-btn>
      <v-btn @click="addRow">Ajouter une ligne</v-btn>
    </v-col>
  </v-row>
</v-container>

      </div>

      <div v-show="projet.bloc_fore && activeTab >= 2">
        <v-alert type="info" class="mt-6 text-left">Cette section est en cours de développement.</v-alert>
      </div>
    <!-------------------------------- Bloc nouveau projet -------------------------------->

      <v-col cols="12" sm="10" class="alignement_input">
      <router-link :to="{ name: 'client', params: { id_entreprise: $route.params.id_entreprise }}" style="text-decoration: none;">
        <v-btn @click="$store.state.currentTab = 1" class="btnBold mr-10" color="black" plain>
          Annuler
        </v-btn>
      </router-link>
      <v-btn class="btnBold" color="#FF9900" dark rounded type="submit">
        <v-icon left>fa fa-save</v-icon>
        ENREGISTRER
      </v-btn>
      </v-col>

      <!-- Snackbar validation errors -->
      <v-snackbar
        v-model="errorSnackbar"
        color="#c62828"
        top
        right
        multi-line
        :timeout="6000"
        min-width="360"
      >
        <div class="d-flex align-start py-1">
          <v-icon class="mr-3 mt-1" size="22">mdi-alert-circle</v-icon>
          <div>
            <div class="font-weight-bold mb-2" style="font-size: 1rem;">Veuillez corriger les erreurs suivantes :</div>
            <ul class="pl-4" style="font-size: 0.92rem;">
              <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
            </ul>
          </div>
        </div>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="errorSnackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      </v-container>
    </form>


  </div>
</template>
<script>
import ProjetBlocDescription from "@/components/Clients/ProjetBlocDescription";
import ProjetEtapes from "@/components/Clients/ProjetEtapes";
import AddArticles from "@/components/Clients/AddArticles";
import AddContacts from "@/components/Clients/AddContacts";
import AddRappels from "@/components/Clients/AddRappels";
import AddDocuments from "@/components/Clients/AddDocuments";
import BlocPlan from "@/components/Clients/BlocPlan";
import api_doc from "@/api/document";

import { required, minLength, maxLength } from "vuelidate/lib/validators";
import moment from "moment";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export default {
  props: {
    projet: Object,
    utilisateurs: Array,
  },
  components: {
    ProjetBlocDescription,
    ProjetEtapes,
    AddContacts,
    AddArticles,
    AddRappels,
    AddDocuments,
    BlocPlan,
  },
  data() {
    return {
      checkIfPersonne: false,
      menu: false,
      activeTab: 0,
      tabErrors: {},
      errorSnackbar: false,
      errorMessages: [],
      http: process.env.VUE_APP_BASE_URL,
      zoomLevel: 1,
      columns: ['Face 1', 'Face 2', 'Face 3', 'Face 4', 'Face 5', 'Face 6'],
      isSelecting: false,
      documents: [],
      selectedFile: null,
      imageUrl: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
      previewIsPdf: false,
      // Bloc image picked before the project exists; uploaded to photos/ on submit.
      pendingImage: null,
      filesToAdd: [],
    };
  },
  validations: {
    projet: {
      nom_projet: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(100),
      },
      date_projet: {
        required,
      },
    },
  },
  computed: {
    blocSrc() {
      return this.projet.document && this.projet.document.chemin ? `${this.http}${this.projet.document.chemin}` : this.imageUrl;
    },
    blocIsPdf() {
      if (this.projet.document && this.projet.document.chemin) {
        return /\.pdf$/i.test(this.projet.document.chemin);
      }
      return this.previewIsPdf;
    },
    formatDate() {
      moment.locale();
      return this.projet.date_projet
        ? moment(this.projet.date_projet).format("L")
        : "";
    },
    createur() {
      const match = this.utilisateurs.find((obj) => obj.id_utilisateur === this.projet.id_utilisateur);
      return match === undefined ? "non défini" : match.nom;
    },
  },
  methods: {
    closeRappel(rappel) {
      this.$emit("closeRappel", { id_rappel: rappel.id_rappel });
    },

    async projectFileUpload() {
      const { documents, newFiles } = this.$refs.AddDocuments.getPayload();

      const uploads = await Promise.all(
        newFiles.map(async ({ file, chemin }) => ({
          name: file.name,
          chemin,
          content: await toBase64(file),
        })),
      );

      if (this.pendingImage) {
        uploads.push(this.pendingImage);
      }

      return { documents, uploads };
    },

    async submit() {
      // Validation du formulaire
      this.$v.$touch();
      this.$refs.ProjetBlocDescription.$v.$touch();
      if (this.projet.bloc_fore) {
        this.$refs.ProjetBlocDescriptionCahier.$v.$touch();
      }

      const projetInvalid = this.$v.$invalid || this.$refs.ProjetBlocDescription.$v.$invalid;
      const cahierInvalid = this.projet.bloc_fore && this.$refs.ProjetBlocDescriptionCahier.$v.$invalid;

      // Update tab error badges
      this.$set(this.tabErrors, 0, projetInvalid);
      this.$set(this.tabErrors, 1, cahierInvalid);

      // Switch to the first tab with errors
      if (projetInvalid) {
        this.activeTab = 0;
      } else if (cahierInvalid) {
        this.activeTab = 1;
      }

      // Build error summary for snackbar
      const msgs = [];
      if (projetInvalid) { msgs.push('Onglet "Projet" : des champs obligatoires sont manquants'); }
      if (cahierInvalid) { msgs.push('Onglet "Cahier des charges" : des champs obligatoires sont manquants'); }
      if (this.projet.personnes.length === 0) { msgs.push('Au moins une personne doit être ajoutée'); }
      if (msgs.length > 0) {
        this.errorMessages = msgs;
        this.errorSnackbar = true;
      }

      if (!projetInvalid && !cahierInvalid && this.projet.personnes.length > 0) {
        // Récupération des data des composant AddContacts, AddRappels
        this.projet.personnes = this.$refs.AddContacts.personnes;
        this.projet.rappels = this.$refs.AddRappels.rappels;

        const documentsPayload = await this.projectFileUpload();

        if (this.projet.commentaire_ !== ""  ) {
          this.projet.commentaires.push({ commentaire : this.projet.commentaire_ })
        }

        // Data du projet
        const obj = {
          id_projet: this.projet.id_projet,
          nom_projet: this.projet.nom_projet,
          date_projet: this.projet.date_projet,
          description: this.projet.description,
          projet_obtenu: this.projet.projet_obtenu,
          commentaire_projet_obtenu: this.projet.commentaire_projet_obtenu,
          id_entreprise: this.$route.params.id_entreprise,
          id_utilisateur: this.projet.id_utilisateur,
          bloc_fore: this.projet.bloc_fore,
          application: this.projet.application,
          fonctionnement_bloc: this.projet.fonctionnement_bloc,
          debit_max: this.projet.debit_max,
          pression_max: this.projet.pression_max,
          protection: this.projet.protection,
          qte_annuelle: this.projet.qte_annuelle,
          qte_livraison: this.projet.qte_livraison,
          prix_objectif: this.projet.prix_objectif,
          matiere_utilisee: this.projet.matiere_utilisee,
          recurrence_fabrication: this.projet.recurrence_fabrication,
          tension: this.projet.tension,
          connecteurs: this.projet.connecteurs,
          type_connecteur: this.projet.type_connecteur,
          etapes: this.projet.etapes,
          outils_specifiques: this.projet.outils_specifiques,
          cartouches_non_stockees: this.projet.cartouches_non_stockees,
          personnes: this.projet.personnes,
          rappels: this.projet.rappels,
          commentaire: this.projet.commentaire_,
          reglage_pression: this.projet.reglage_pression,
          frequence_test: this.projet.frequence_test,
          articles: this.projet.projet_a_articles,
          bloc_longueur: this.projet.longueur,
          bloc_largeur: this.projet.largeur,
          bloc_hauteur: this.projet.hauteur,
          face_6: this.projet.face_6,
          faces: this.projet.rows,
        }

        this.tabErrors = {};
        this.$emit('emitProjet', {
          projet: obj,
          documentsPayload: documentsPayload,
        });
      } else {
        this.checkIfPersonne = true;
      }

      // Scroll sur la première erreur de vuelidate
      if (projetInvalid || cahierInvalid) {
        this.$nextTick(() => {
          const domRect = document.querySelector('.errorMsg');
          if (domRect) { domRect.scrollIntoView(); }
        });
      }
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true },
      );
      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      this.documents = [];
      this.selectedFile = e.target.files[0];
      this.documents.push({ files: this.selectedFile });

      const uploadFile = this.selectedFile;
      e.target.value = '';
      toBase64(uploadFile).then((content) => {
        this.projet.document = null;
        // PDFs are previewed from a blob URL (large data: URLs are not rendered in <object>)
        this.previewIsPdf = uploadFile.type === 'application/pdf' || /\.pdf$/i.test(uploadFile.name);
        if (this.imageUrl.startsWith('blob:')) { URL.revokeObjectURL(this.imageUrl); }
        this.imageUrl = URL.createObjectURL(uploadFile);

        // The bloc image lives in the project's photos/ folder.
        if (this.projet.id_projet === undefined) {
          this.pendingImage = { name: uploadFile.name, chemin: '/photos/' + uploadFile.name, content };
          return;
        }
        const id_entreprise = this.$route.params.id_entreprise;
        const upload = {
          name: uploadFile.name,
          chemin: `uploads/${id_entreprise}/projets/${this.projet.id_projet}/photos/${uploadFile.name}`,
          content,
        };
        return api_doc.uploadProjectDocuments(id_entreprise, this.projet.id_projet, { uploads: [upload] });
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
      });
    },

    zoomIn() {
      const sensitivity = 0.1; // Sensitivity of zoom level change
      this.zoomLevel = Math.min(3, this.zoomLevel + sensitivity);
    },
    zoomOut() {
      const sensitivity = 0.1; // Sensitivity of zoom level change
      this.zoomLevel = Math.max(1, this.zoomLevel - sensitivity);
    },

    createNewRow() {
      const newRow = {};
      for (let i = 1; i <= this.columns.length; i++) {
        newRow['face' + i] = '';
      }
      return newRow;
    },
    addRow() {
      if (!this.projet.rows) { this.projet.rows = []; }
      this.projet.rows.push(this.createNewRow());
    },
    removeRow() {
      this.projet.rows.pop();
    },
  },
};
</script>
<style scoped>
.calendar-field {
  width: 20%;
}

.labelCheckbox {
  align-items: center;
  display: inline-flex;
  flex: 1 1 auto;
  height: 24px;
}

.date-letter {
  font-size: 15px !important;
}

.text-modal {
  color: black;
  font-weight: normal;
  font-size: large;
}

.card_border.v-card.v-sheet.theme--light {
  border-radius: 15px;
}

.btn_choice {
  min-width: 110px !important;
  background-color: #0a6e97;
  padding: 1.2em 3em;
  color: #fff;
  font-size: 1em;
  font-weight: bold;
  margin-bottom: 1em;
}

img {
  width: 29px;
  height: 28px;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
}

.width-50 {
  width: 30%;
}

.addPersonne {
  border-style: dashed;
  border-color: blue;
  color: blue;
}

.btnBold {
  font-weight: bold;
}

.errorMsg {
  text-align: left;
  color: red;
}


.image-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
}

  .table-header {
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
  }

  .table-row {
    border-bottom: 1px solid #ddd;
  }

  .table-fields {
    border: 1px solid #ddd;
  }

    .table-cell {
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .remove-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
